import configHandler from '../../configHandler'

const ERROR_INVALID_ORG_NUMBER = 'invalidNumber'

const checkMod10 = (number) => {
    let sum = 0
    let numDigits = number.length - 1
    let parity = numDigits % 2

    for (let i = numDigits; i >= 0; i--) {
        let digit = parseInt(number.substring(i, i+1))
        if (parity !== (i % 2)) {
            digit <<= 1
        }
        digit = (digit > 9) ? (digit - 9) : digit
        sum += digit
    }
    return (sum % 10) === 0
}

export default (input) => {
    return {
        input,
        isRequired: false,

        required: function () {
            this.isRequired = true
            return this
        },

        format: function () {
            const parsed = this.parsed()
            if (!this.isValid() || !parsed.length) {
                return parsed
            }
            return parsed.substring(0, 6) + '-' + parsed.substring(6)
        },

        isValid: function () {
            return this.validate().length === 0
        },

        validate: function () {
            const errors = []
            const orgNumber = this.parsed()
            if (orgNumber === null || orgNumber === '') {
                if (this.isRequired) {
                    errors.push(configHandler.errorMessages().orgNumber[ERROR_INVALID_ORG_NUMBER])
                }
                return errors
            }

            if (isNaN(parseInt(orgNumber)) || orgNumber.length !== 10) {
                errors.push(configHandler.errorMessages().orgNumber[ERROR_INVALID_ORG_NUMBER])
                return errors
            }

            if (checkMod10(orgNumber)) {
                return []
            }
            errors.push(configHandler.errorMessages().orgNumber[ERROR_INVALID_ORG_NUMBER])
            return errors
        },

        value: function () {
            return this.input
        },
    }
}